:host {
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

:host(.radio--column) {
  display: flex;
  flex-direction: column;
}